var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"an-select-modal"},[_c(_vm.modalTab,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }